import { FunctionComponent, ReactNode } from "react";

import styled from "styled-components";

import { Tooltip } from "components/base";
import { ActionButton } from "components/shared/ActionButton";

interface MonthlyDisabledButtonProps {
  label: string;
  reason: string;
  // Ties the visually hidden reason to the button as its description.
  reasonId: string;
  children: ReactNode;
}

// aria-disabled, not disabled, so the button keeps focus and hover for its tooltip. The
// name stays the action's; the reason is its description.
const MonthlyDisabledButton: FunctionComponent<MonthlyDisabledButtonProps> = ({
  label,
  reason,
  reasonId,
  children
}) => (
  <>
    <Tooltip title={reason}>
      <DisabledButton
        type="button"
        aria-disabled="true"
        aria-label={label}
        aria-describedby={reasonId}
        onClick={(event) => event.preventDefault()}>
        {children}
      </DisabledButton>
    </Tooltip>
    <span id={reasonId} className="visually-hidden">
      {reason}
    </span>
  </>
);

export default MonthlyDisabledButton;

const DisabledButton = styled(ActionButton)`
  opacity: 0.5;
  cursor: not-allowed;

  &:hover {
    color: var(--color-action-button);
  }
`;
